import i18n from "../i18n";

const initialState = {
    value: (localStorage.getItem('userLang') && localStorage.getItem('userLang') !== undefined && localStorage.getItem('userLang') !== '') ? (localStorage.getItem('userLang').split('-'))[0] : (i18n.language || 'en'),
    availableLocales: [],
    adobeGlobalNavLocale:(localStorage.getItem('globalLocale') && localStorage.getItem('globalLocale') !== undefined && localStorage.getItem('globalLocale') !== '') ? localStorage.getItem('globalLocale') : 'en_US',
    languageCode: (localStorage.getItem('i18nextLng') && localStorage.getItem('i18nextLng') !== undefined && localStorage.getItem('i18nextLng') !== '') ? localStorage.getItem('i18nextLng') : 'en'
};


const LocaleReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_LOCALE':{
            return  {
                ...state,
                value:action.value
            }
        }
        case 'SET_LOCALE_LANGUAGE':{
            return  {
                ...state,
                languageCode:action.value
            }
        }
        case 'SET_AVAILABLE_LOCALE':{
            return  {
                ...state,
                availableLocales:action.value
            }
        }
        case 'SET_NAV_LOCALE':{
            return  {
                ...state,
                adobeGlobalNavLocale:action.value
            }
        }
        default:
            return state;
    }

};

export default LocaleReducer;
